import { Component, Input, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

import { CtxButtonComponent } from '../button/button.component';
import type { ResourceTableService } from '../../_services/resource-table.service';
import { HlmIconComponent } from '../icon';
import { TableMenuAction } from 'utils';
import { TrialExpireService } from '../../_services/trail-expired.service';
import { AuthnService } from '../../_services/authn.service';

/**
 * Generic page for entities. Shows tables and actions.
 */
@Component({
  selector: 'ctx-resource-actions',
  templateUrl: './resource-actions.component.html',
  standalone: true,
  imports: [CtxButtonComponent, MatMenuModule, HlmIconComponent],
})
export class CtxResourceActionsComponent implements OnInit {
  constructor(
    public authn: AuthnService,
    public TrialExpireService: TrialExpireService
  ) {}
  ngOnInit() {
    /**
     * for loop targets a hardcoded array, it will work, if it targets a method returning a hard coded array it will not bind click.
     * https://stackoverflow.com/questions/71011494/angular-8-click-event-not-firing-inside-ngfor-when-iterating-over-object-array
     */
    this.menuActions = this.resourceTableService.actions.menuActions;
  }

  menuActions?: TableMenuAction[];
  /** Response object for the resource from the Web API */
  @Input() resource: Record<string, any>;

  /** Used to fetch the actions from resourceTableService.actions.menuActions */
  @Input() resourceTableService: ResourceTableService;

  /** Button type */
  @Input() type: 'icon' | 'primary' = 'primary';

  /** True if all actions in actions menu are disabled */
  isActionsMenuEmpty(resource: any) {
    return this.resourceTableService.actions.menuActions?.every((action) => {
      return action.disabled && action.disabled(resource);
    });
  }

  icon = (menuAction: TableMenuAction, resource: any) => {
    return typeof menuAction.icon === 'string'
      ? menuAction.icon
      : menuAction.icon(resource);
  };
}
